import React, { useState, useEffect } from 'react';
import QRScannerComponent from '../components/QRScannerComponent';
import { db } from '../firebaseConfig';
import { doc, getDoc, updateDoc, serverTimestamp, collection, query, where, getDocs } from 'firebase/firestore';

const successAudio = new Audio('/success.mp3');
const errorAudio = new Audio('/error.mp3');

const CheckInPage = () => {
  const [ticketData, setTicketData] = useState(null);
  const [status, setStatus] = useState('');
  const [scannedCode, setScannedCode] = useState(null);
  const [showWelcome, setShowWelcome] = useState(false);
  const [totalCheckedIn, setTotalCheckedIn] = useState(0);

  useEffect(() => {
    const fetchCheckedInCount = async () => {
      const q = query(collection(db, 'tickets'), where('checkedIn', '==', true));
      const snap = await getDocs(q);
      setTotalCheckedIn(snap.size);
    };
    fetchCheckedInCount();
  }, [showWelcome]);

  const handleScanSuccess = async (code) => {
    if (!code || code === scannedCode) return;
    setScannedCode(code);
    setStatus('⏳ Processing check-in...');

    try {
      const ticketRef = doc(db, 'tickets', code);
      const snap = await getDoc(ticketRef);

      if (!snap.exists()) {
        setStatus('❌ Ticket not found.');
        errorAudio.play();
        setTicketData(null);
        setShowWelcome(false);
        return;
      }

      const data = snap.data();

      if (data.checkedIn) {
        setStatus('⚠️ This ticket has already been checked in.');
        errorAudio.play();
        setTicketData(data);
        setShowWelcome(true);
        return;
      }

      await updateDoc(ticketRef, {
        checkedIn: true,
        checkedInAt: serverTimestamp(),
      });

      setTicketData({ id: code, ...data });
      setStatus('✅ Check-in successful!');
      successAudio.play();
      setShowWelcome(true);

    } catch (err) {
      console.error('Error:', err);
      setStatus('❌ Something went wrong.');
      errorAudio.play();
      setTicketData(null);
      setShowWelcome(false);
    }
  };

  const handleReset = () => {
    setTicketData(null);
    setStatus('');
    setScannedCode(null);
    setShowWelcome(false);
  };

  const getLifestage = (age, civilStatus) => {
    const a = parseInt(age);
    if ((civilStatus || '').toLowerCase() === 'married') return 'Couples';
    if (!isNaN(a) && a <= 21) return 'Elevate';
    return 'Singles';
  };

  if (showWelcome && ticketData) {
    return (
      <div style={{ background: '#001a1a', color: '#fff', height: '100vh', padding: '40px', textAlign: 'center' }}>
        <h1>🎉 Welcome {ticketData.firstName || ''} {ticketData.lastName || ''}!</h1>
        <p><strong>Lifestage:</strong> {getLifestage(ticketData.age, ticketData.civilStatus)}</p>
        <p><strong>Table:</strong> {ticketData.tableNumber || 'N/A'}</p>
        <p><strong>Facilitator:</strong> {ticketData.assignedFacilitator || 'Unassigned'}</p>
        <p><strong>Total Checked-In:</strong> {totalCheckedIn}</p>
        <p style={{ color: status.includes('✅') ? 'lightgreen' : 'orange', marginTop: '20px' }}>{status}</p>
        <button onClick={handleReset} style={buttonStyle}>🎫 Scan Next Ticket</button>
      </div>
    );
  }

  return (
    <div style={{ background: '#000', color: '#fff', height: '100vh' }}>
      <QRScannerComponent onScanSuccess={handleScanSuccess} />
      {status && (
        <div style={{ textAlign: 'center', paddingTop: '20px', fontSize: '18px', fontWeight: 'bold', color: '#ffcc00' }}>
          {status}
        </div>
      )}
    </div>
  );
};

const buttonStyle = {
  marginTop: '30px',
  padding: '12px 24px',
  fontSize: '16px',
  backgroundColor: '#00cc99',
  color: '#33001a',
  border: 'none',
  borderRadius: '6px',
  cursor: 'pointer'
};

export default CheckInPage;
